<template>
    <div style="overflow: hidden;width: 100%">
        <CommonHeader/>
        <div class="container" >
            <a-row></a-row>
            <div style="height: 20px;">
                <a-col class="mt-6 mb-3" :span="24">
                    <a-breadcrumb>
                        <a-breadcrumb-item><a href="">首页</a></a-breadcrumb-item>
                        <a-breadcrumb-item>绑定供应商</a-breadcrumb-item>
                    </a-breadcrumb>
                </a-col>
            </div>
            <div style="margin-top: 50px;"></div>
            <a-card>
                <div class="mt-7"></div>
                <a-form :form="form" >
                <table style="width:70%;align:center;margin-left: 15%;margin-bottom: 150px;" >
                    <tr>
                        <th>单位名称:</th>
                        <td>
                            {{supplier.supplierName}}
                        </td>
                    </tr>
                    <tr>
                        <th>统一社会信用代码:</th>
                        <td>
                         {{supplier.supplierCode}}
                        </td>
                    </tr>
                    <tr>
                        <th>管理员:</th>
                        <td>
                            {{adminName}}
                        </td>
                    </tr>
                    <tr>
                        <th>管理员手机号:</th>
                        <td>
                            <a-input
                                    style="width: 300px;"
                                    placeholder = '输入管理员手机号'
                                    v-model="phone"
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>
                            获取验证码:
                        </th>
                        <td>
                            <a-button    @click="checkPhoneNumber"> {{btnMsg}}</a-button>
                            <span> &nbsp;&nbsp;&nbsp;</span>
                            <a-input
                                    style="width: 180px;"
                                    v-model="phoneCode"
                                    placeholder = '管理员手机号验证码'></a-input>
                        </td>
                    </tr>
                    <tr>
                        <th>关联供应商:</th>
                        <td>
                            <a-button type="primary" @click="connect">确认</a-button>
                        </td>
                    </tr>
                </table>
                </a-form>
            </a-card>
        </div>
        <CommonFooter/>
    </div>
</template>

<script>
    import qs from 'qs'
    import CommonHeader from '../common/CommonHeader'
    import CommonFooter from '../common/CommonFooter'

    export default {
        name: 'ConnectSupplier',
        created() {
            this.initData()
        },
        destroyed() {
            this.disabled = false
            if (this.timer) {
                clearInterval(this.timer)
            }
        },
        components: {
            CommonHeader,
            CommonFooter,

        },
        data() {
            return {
                loading: false,
                form: this.$form.createForm(this),
                id: this.$route.query.id,
                supplier:'',
                phone: '',
                disabled:false,
                timer: '',
                minus: 0,
                btnMsg: '发送验证码',
                phoneCode: '',
                adminName:'',
                account:'',
                supplierCode: this.$route.params.supplierCode
            };
        },
        methods: {
            initData() {
                let that = this
                var url = '/api/v1/supplier/account/get_supplier_admin.json'
                if (that.supplierCode) {
                    url += "?supplierCode="+that.supplierCode
                }
                this.$http.get(url).then(function (res) {
                    if (res.result) {
                        debugger
                        that.supplier = res.result
                        that.adminName = that.supplier.extras.admin
                    }
                });
            },
            // getStatus() {
            //     let that = this
            //     this.$http.get("/api/v1/supplier/account/get_account_info2.json").then(function (res) {
            //         if (res.code === 200) {
            //             that.account =  res.result
            //             if (that.account.supplierId) {
            //                 that.$router.push({path:'/index'})
            //             }
            //         }
            //     });
            // },
            sendCode() {
                if (this.disabled) {
                    return;
                }
                let that = this
                this.$http.get('/api/v1/supplier/account/send_code_connect.json?phone='+that.phone).then(function (res) {
                    if (res.code === 200) {
                        that.disabled = true
                        that.minus = 60
                        // 发送验证码
                        that.timer = setInterval(that.countDown,1000)
                    }else {
                        that.$message.error("验证码已失效!")
                    }
                });
                    },
            countDown() {
                if (this.minus <= 0) {
                    this.disabled = false
                    this.btnMsg = "发送验证码"
                    clearInterval(this.timer)
                    return
                }
                this.minus = this.minus - 1
                this.btnMsg = this.minus + "  s后重发";
            },
            connect() {
                // var regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
                var regExp = /^[1][3-9][0-9]{9}$/

                if (!regExp.test(this.phone)) {
                    this.$message.error("手机格式不正确");
                    return
                }
                if (!this.phoneCode) {
                    this.$message.error("验证码不能为空");
                    return
                }
                let  that  = this
                this.$http.get("api/v1/supplier/account/validate_admin_phone.json?phone="+that.phone + "&code="+that.supplier.supplierCode).then(function (res) {
                    if (res.code === 200) {
                        that.cmtConnectInfo()
                    }else if (res.code === 100) {
                        that.$message.error(res.msg)
                    }
                });

            },
            cmtConnectInfo() {
                let that = this
                this.$http.get("api/v1/supplier/account/cmtConnectInfo.json?phone="+this.phone + "&phoneCode="+this.phoneCode).then(function (res) {
                    if (res.code === 200) {
                        that.$message.info("绑定成功!")
                        that.disabled = false
                        that.btnMsg = "发送验证码"
                        clearInterval(that.timer)
                        that.$router.push({path:'/index'})
                    }else if (res.code === 100) {
                        that.$message.error(res.msg);
                    }
                });
            },
            checkPhoneNumber() {
                // var regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
                var regExp = /^[1][3-9][0-9]{9}$/
                if (!regExp.test(this.phone)) {
                    this.$message.error("手机格式不正确")
                    return
                }
                let that = this
                this.$http.get("api/v1/supplier/account/validate_admin_phone.json?phone="+that.phone + "&code="+that.supplier.supplierCode).then(function (res) {
                    if (res.code === 200) {
                        that.sendCode()
                    }else if (res.code === 100) {
                        that.$message.error(res.msg)
                    }
                });
            },
            sysInfo(value) {
                this.$success({
                    title: '提示',
                    content:value
                })
            }
        },
    };
</script>
<style lang="less" scoped>
    .i-my-info {
        overflow: hidden;
        width: 100%;
        height: 225px;
        position: relative
    }

    .index-bg {
        position: absolute;
        width: 1920px;
        left: 50%;
        margin-left: -960px;
    }

    .main-nav a {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        background: rgba(255, 255, 255, 0.3);
        margin-right: 2px;
    }

    .main-nav a b {
        color: #fff;
        font-weight: 500;
        margin-left: 10px;
    }

    .main-nav a .icon:nth-child(1) {
        display: none;
    }

    .main-nav .active {
        background: #f9f9f9;
    }

    .main-nav .active .icon:nth-child(1) {
        display: block;
    }

    .main-nav .active .icon:nth-child(2) {
        display: none;
    }

    .main-nav .active b {
        color: inherit;
    }

    .main-nav a:hover {
        background: #fff;
    }

    .main-nav a:hover b {
        color: inherit;
    }

    .main-nav a:hover .icon:nth-child(1) {
        display: block;
    }

    .main-nav a:hover .icon:nth-child(2) {
        display: none;
    }

    .icon {
        width: 36px;
        height: 36px;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
        line-height: 30px;
        display: block;
    }

    .handle {
        background: #fff;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        padding: 12px 0;
        z-index: 9;
    }

    .handle .right {
        position: absolute;
        right: 0;
        top: 0;
        height: 32px;
        display: flex;
        align-items: center;
    }

    .handle .right > a:hover {
        color: #2eabff !important;
    }

    .handle .logo {
        display: inline-flex;
        align-items: center;
    }

    .handle .logo img {
        width: 32px;
        height: 32px;
    }

    .handle .logo p {
        font-size: 18px;
        color: #262626;
        margin: 0 0 0 12px;
    }

    .index-info {
        display: flex;
        align-items: center;
        color: #fff;
    }

    .index-info img {
        display: block;
    }

    .index-info p {
        margin: 0;
    }

    /*.shadow{*/
    /*    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2);*/
    /*    border-radius: 6px;*/
    /*}*/
    .shadow:hover {
        background: #f1f9ff;
    }

    .my-info {
        width: 100%;
        color: #262626;
        table-layout: fixed;
    }

    .my-info th {
        width: 130px;
        padding: 6px 0;
        color: #8c8c8c;
        font-weight: 500;
    }

    .personal {
        font-size: 0;
        margin: 0 -16px;
    }

    .personal .p-col {
        width: 33.333333%;
        padding: 16px;
        display: inline-block;
    }

    .p-card {
        box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
        overflow: hidden;
        border-radius: 5px;
        position: relative;
    }

    .p-card .p-info {
        font-size: 14px;
        display: inline-block;
        vertical-align: top;
        margin: 10px 20px;
    }

    .p-card .p-info td {
        padding: 6px 20px;
    }

    .p-card .p-icon {
        display: inline-block;
        vertical-align: top;
        background: #F6B897;
        color: #fff;
        height: 120px;
        width: 80px;
        line-height: 120px;
        text-align: center;
        font-size: 30px;
    }

    .p-card .operate {
        font-size: 14px;
        margin-top: 12px;
        position: absolute;
        right: 12px;
    }

    .p-card .operate:hover {
        color: rgb(255, 89, 89);
        cursor: pointer;
    }
    table tr{
        height: 50px;
    }
</style>
